export default "__VITE_ASSET__aead93bb__"